// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton {
    opacity: 1;
    animation: SkeletonAnim 1.5s infinite;
    background: #c4c4c4;
}

@keyframes SkeletonAnim {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/skeleton/style.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".skeleton {\n    opacity: 1;\n    animation: SkeletonAnim 1.5s infinite;\n    background: #c4c4c4;\n}\n\n@keyframes SkeletonAnim {\n    0% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.5;\n    }\n    100% {\n        opacity: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
